import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';

/**
 * Operations a page is waiting on and will report the outcome of itself, so the background
 * notifications don't repeat it. Kept in memory only: after a reload nothing is waiting any more.
 */
const watchedOperationIdsAtom = atom<ReadonlySet<string>>(new Set<string>());

export function useWatchedOperationIds() {
  return useAtomValue(watchedOperationIdsAtom);
}

export function useWatchOperation() {
  const setWatchedOperationIds = useSetAtom(watchedOperationIdsAtom);

  const watchOperation = useCallback(
    (operationId: string) => setWatchedOperationIds((prev) => new Set(prev).add(operationId)),
    [setWatchedOperationIds],
  );

  const unwatchOperation = useCallback(
    (operationId: string) =>
      setWatchedOperationIds((prev) => {
        if (!prev.has(operationId)) {
          return prev;
        }

        const next = new Set(prev);
        next.delete(operationId);
        return next;
      }),
    [setWatchedOperationIds],
  );

  return { unwatchOperation, watchOperation };
}
